import { Observable, Subscription } from 'rxjs';
import { timer } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { setInterval, setTimeout } from 'timers';

export class CohortPollingHelpers {
  static createHalfHourTimer$() {
    const now = new Date();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const ms = now.getMilliseconds();

    const minutesUntilNext =
      minutes % 30 === 0 && seconds === 0
        ? 0 // Start immediately if exactly at :00 or :30
        : 30 - (minutes % 30);

    const initialDelay = minutesUntilNext * 60 * 1000 - seconds * 1000 - ms;

    return timer(initialDelay, 30 * 60 * 1000).pipe(startWith(0)); // Emit immediately with value 0
  }

  static timedPollUntil$<T>(
    observable: Observable<T>,
    pollIntervalMs: number,
    getPollStartTimeMs: (firstResponse: T) => number,
    pollCompleteCondition: (response: T) => boolean
  ): Observable<T> {
    return new Observable((subscriber) => {
      let subscription: Subscription | null = null;
      let timeout: ReturnType<typeof setTimeout>;
      let interval: ReturnType<typeof setInterval>;
      let hasScheduledPolling = false;

      const clearTimerForMode = (isPolling: boolean) => {
        isPolling ? clearInterval(interval) : clearTimeout(timeout);
      };

      const schedulePolling = (response: T) => {
        hasScheduledPolling = true;
        const pollStartTime = getPollStartTimeMs(response);
        const bufferMs = Math.max(pollStartTime, pollIntervalMs);

        const startPolling = () => {
          handleSubscription(false);
          interval = setInterval(() => handleSubscription(true), pollIntervalMs);
        };

        timeout = setTimeout(startPolling, bufferMs);
      };

      /** @returns true if the observable has completed, false otherwise */
      const handleSuccess = (response: T, isPolling: boolean) => {
        subscriber.next(response);

        if (pollCompleteCondition(response)) {
          clearTimerForMode(isPolling);
          subscriber.complete();
          return true;
        }

        const shouldSchedulePolling = !hasScheduledPolling && !isPolling;
        if (shouldSchedulePolling) {
          schedulePolling(response);
        }

        return false;
      };

      const handleError = (err: any, isPolling: boolean) => {
        clearTimerForMode(isPolling);
        subscriber.error(err);
      };

      const handleSubscription = (isPolling: boolean = false) => {
        if (subscription) subscription.unsubscribe();
        subscription = observable.subscribe(
          (response) => handleSuccess(response, isPolling),
          (err) => handleError(err, isPolling)
        );
      };

      handleSubscription();

      return () => {
        clearTimeout(timeout);
        clearInterval(interval);
        subscription.unsubscribe();
      };
    });
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/cohort/cohort-polling.helpers.ts